"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var letter = /[a-zA-Z]/;
var number = /[0-9]/;
var symbol = /`|~|!|@|#|\$|%|\^|&|\*|\(|\)|-|_|=|\+|\[|\{|\]|\}|\\|\||;|:|'|"|,|<|.|>|\/|\?/;
function isLetter(event) {
    return event.key.length === 1 && letter.test(event.key);
}
function isNumber(event) {
    return event.key.length === 1 && number.test(event.key);
}
function isSpace(event) {
    return event.key === ' ' || event.key === 'Spacebar';
}
function isSymbol(event) {
    return event.key.length === 1 && symbol.test(event.key);
}
function isPrintable(event) {
    return isLetter(event) || isNumber(event) || isSpace(event) || isSymbol(event);
}
function isEnter(event) {
    return event.key === 'Enter';
}
function isAlt(event) {
    return event.key === 'Alt';
}
function isControl(event) {
    return event.key === 'Control';
}
function isBackspace(event) {
    return event.key === 'Backspace';
}
function isDelete(event) {
    return event.key === 'Delete' || event.key === 'Del';
}
function isEscape(event) {
    return event.key === 'Escape' || event.key === 'Esc';
}
function isTab(event) {
    return event.key === 'Tab';
}
function isHome(event) {
    return event.key === 'Home';
}
function isEnd(event) {
    return event.key === 'End';
}
function isPageUp(event) {
    return event.key === 'PageUp';
}
function isPageDown(event) {
    return event.key === 'PageDown';
}
function isUpArrow(event) {
    return event.key === 'ArrowUp' || event.key === 'Up';
}
function isDownArrow(event) {
    return event.key === 'ArrowDown' || event.key === 'Down';
}
function isLeftArrow(event) {
    return event.key === 'ArrowLeft' || event.key === 'Left';
}
function isRightArrow(event) {
    return event.key === 'ArrowRight' || event.key === 'Right';
}
function isArrow(event) {
    return isUpArrow(event) || isDownArrow(event) || isLeftArrow(event) || isRightArrow(event);
}
function isNavigation(event) {
    return (isTab(event) ||
        isArrow(event) ||
        isHome(event) ||
        isEnd(event) ||
        isPageUp(event) ||
        isPageDown(event));
}
exports.default = {
    isLetter: isLetter,
    isNumber: isNumber,
    isSpace: isSpace,
    isSymbol: isSymbol,
    isPrintable: isPrintable,
    isEnter: isEnter,
    isAlt: isAlt,
    isControl: isControl,
    isDelete: isDelete,
    isBackspace: isBackspace,
    isEscape: isEscape,
    isTab: isTab,
    isHome: isHome,
    isEnd: isEnd,
    isPageUp: isPageUp,
    isPageDown: isPageDown,
    isUpArrow: isUpArrow,
    isDownArrow: isDownArrow,
    isLeftArrow: isLeftArrow,
    isRightArrow: isRightArrow,
    isArrow: isArrow,
    isNavigation: isNavigation,
};
